export const CONFERENCE_INFO = {
    alwaysVisible: ['raised-hands-count', 'recording'],
    autoHide: [
        'highlight-moment',
        'subject',
        'conference-timer',
        'participants-count',
        'e2ee',
        'transcribing',
        // No 'video-quality': its gauge sat at the top of every call and
        // distracted (Robert, 2026-09-25). Native shows only "Audio only".
        'visitors-count',
        'insecure-room',
        'top-panel-toggle'
    ]
};
